<template lang="pug"></template>

<script>
export default {
    name: 'BotaoPreAnalise',
    componentOptions: {
        title: 'Pré-Analise',
        actions: [
            [
                {
                    name: 'pre-analise-credito',
                    iconClass: 'lyra-icon lyra-pre-analise-credito',
                    action: 'abrir',
                    route: 'pre-analise-credito',
                    nameTranslationKey:
                        'mensagens.menuLateral.preanaliseDeCredito'
                }
            ]
        ]
    },

    methods: {
        abrirPreAnalise() {
            if (this.$route.name !== 'pre-analise-credito') {
                this.$router.push({ name: 'pre-analise-credito' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
